import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.principal').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.principal', {
                abstract: true,
                template: '<ui-view/>',
            })
            // Création d'un DO
            .state('app.principal.create', {
                abstract: true,
                component: 'principalLayout',
                resolve: {
                    create: function () {
                        return true;
                    },
                    principal: getCreatePrincipal,
                },
            })
            .state('app.principal.create.detail', {
                url: '/principal/create/detail',
                resolve: {
                    countries: getCountries,
                    allDematPlatforms: getAllDematPlatforms,
                },
                data: {
                    firstStep: true,
                    principalCreation: true,
                },
                views: {
                    content: {
                        component: 'principalDetail',
                    },
                },
            })
            .state('app.principal.create.configportal', {
                url: '/principal/create/config-portal',
                params: {
                    eid: null,
                },
                data: {
                    principalCreation: true,
                },
                views: {
                    content: {
                        component: 'principalConfigPortal',
                    },
                },
            })
            .state('app.principal.create.kiss', {
                url: '/principal/create/kiss',
                data: {
                    principalCreation: true,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalKiss',
                    },
                },
            })
            .state('app.principal.create.epdf', {
                url: '/principal/create/epdf',
                data: {
                    principalCreation: true,
                },
                resolve: {
                    ladProviders: listLadProviders,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalEpdf',
                    },
                },
            })
            // Import d'un DO
            .state('app.principal.principalImport', {
                url: '/principal/import',
                component: 'principalImport',
                resolve: {
                    importResults: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().importResults;
                        },
                    ],
                    allDematPlatforms: getAllDematPlatforms,
                },
                params: {
                    importResults: null,
                },
            })
            // Consultation d'un DO
            .state('app.principal.consult', {
                url: '/principal/consult/:id',
                component: 'principalLayout',
                resolve: {
                    create: function () {
                        return false;
                    },
                    setPrincipalId: setPrincipalId,
                    initMenuConsult: initMenuConsult,
                    getPrincipalStatus: getPrincipalStatus,
                },
                redirectTo: 'app.principal.consult.detail',
            })
            .state('app.principal.consult.detail', {
                url: '/detail',
                resolve: {
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    allDematPlatforms: getAllDematPlatforms,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalDetail',
                    },
                },
            })
            .state('app.principal.consult.configportal', {
                url: '/config-portal',
                resolve: {
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                },
                views: {
                    content: {
                        component: 'principalConfigPortal',
                    },
                },
            })
            .state('app.principal.consult.personaliseportal', {
                url: '/personalise-portal',
                resolve: {
                    brand: getBrand,
                    mode: function () {
                        return 'PRINCIPAL';
                    },
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalPersonalisePortal',
                    },
                },
            })
            .state('app.principal.consult.kiss', {
                url: '/kiss',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    principal: getPrincipal,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalKiss',
                    },
                },
            })
            .state('app.principal.consult.offreApi', {
                url: '/offreApi',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    functionalType: () => 'INVOICE',
                    dictionnaireAttributs : getDictionaryAttributs,
                    offresApiConfig: getOffresApi

                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalOffreApi',
                    },
                },
            })
            .state('app.principal.consult.acquittal', {
                url: '/acquittal',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    offresApiConfig: getOffresApiForLegalEntity,
                    principal: getPrincipal,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalAcquittal',
                    },
                },
            })
            .state('app.principal.consult.epdf', {
                url: '/epdf',
                resolve: {
                    countries: () => null,
                    ladProviders: listLadProviders,
                    principal: getPrincipal,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalEpdf',
                    },
                },
            })
            .state('app.principal.consult.referential', {
                url: '/referentials',
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'listReferentialsPrincipal',
                    },
                },
            })
            .state('app.principal.consult.documentaryspace', {
                url: '/documentary-space',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    documentarySpace: documentarySpace,
                    principal: getPrincipal,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'documentarySpace',
                    },
                },
            })
            .state('app.principal.consult.listcompanies', {
                url: '/list-companies',
                resolve: {
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    keepSearchData: keepCompanySearchData,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'companiesList',
                    },
                },
            })
            .state('app.principal.consult.detailscompanies', {
                url: '/details-companies/:legalEntityId',
                resolve: {
                    functionalType: () => 'INVOICE',
                    dictionnaireAttributs: getDictionaryAttributs,
                    legalEntity: getLegalEntity,
                    regSchemes: getRegScheme,
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    previousState: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().previousState;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'companiesDetails',
                    },
                },
                params: {
                    previousState: null,
                },
            })
            .state('app.principal.consult.details_subentity', {
                url: '/:legalEntityId/create-subentity',
                resolve: {
                    ladProviders: () => null,
                    principal: getPrincipal,
                    legalEntity: getLegalEntity,
                    countries: getCountries,
                    previousState: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().previousState;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'subentityDetails',
                    },
                },
                params: {
                    forCreation: true,
                    previousState: null,
                    subEntity: null,
                    subEntityCgv: null,
                },
            })
            .state('app.principal.consult.details_subentities', {
                url: '/details-subentities/:subEntityId',
                resolve: {
                    countries: getCountries,
                    ladProviders: () => null,
                    subEntity: getSubEntity,
                    principal: getPrincipal,
                    subEntityCgv: getCgvOfSubEntity,
                    previousState: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().previousState;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'subentityDetails',
                    },
                },
                params: {
                    previousState: null,
                },
            })
            .state('app.principal.consult.details_divisions', {
                url: '/details-divisions/:subEntityId',
                resolve: {
                    countries: function () {
                        return null;
                    },
                    ladProviders: function () {
                        return null;
                    },
                    division: getSubEntity,
                    principal: getPrincipal,
                    subEntityCgv: getCgvOfSubEntity,
                    previousState: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().previousState;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'divisionDetails',
                    },
                },
                params: {
                    previousState: null,
                },
            })
            .state('app.principal.consult.create_company', {
                url: '/new-company',
                resolve: {
                    functionalType: () => 'INVOICE',
                    dictionnaireAttributs: getDictionaryAttributs,
                    legalEntity: getNewLegalEntity,
                    regSchemes: getRegScheme,
                    countries: getCountries,
                    offresApiConfig: getOffresApiForLegalEntity,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    previousState: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().previousState;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'companiesDetails',
                    },
                },
            })
            .state('app.principal.consult.detailscontainer', {
                url: '/container/{mode}/?{principalId:[0-9]*}/{companyId:[0-9]*}/{containerMode:(STANDARD|KISS)}',
                resolve: {
                    container: [
                        '$transition$',
                        'Containers',
                        function ($transition$, Containers) {
                            return Containers.getNew({
                                principalId: $transition$.params().principalId,
                                companyId: $transition$.params().companyId,
                                containerMode: $transition$.params().containerMode,
                            }).$promise;
                        },
                    ],
                    mode: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().mode;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'containerEdit',
                    },
                },
            })
            .state('app.principal.consult.updatecontainer', {
                url: '/container/{containerId:[0-9]+}/{mode}',
                resolve: {
                    container: [
                        '$transition$',
                        'Containers',
                        function ($transition$, Containers) {
                            return Containers.get({ containerId: $transition$.params().containerId }).$promise;
                        },
                    ],
                    mode: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().mode;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'containerEdit',
                    },
                },
            })
            .state('app.principal.consult.listsellers', {
                url: '/list-sellers',
                resolve: {
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    keepSearchData: keepSellerSearchData,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'sellersList',
                    },
                },
            })
            .state('app.principal.consult.listbuyers', {
                url: '/list-buyers',
                resolve: {
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    keepSearchData: keepSellerSearchData,
                    getPrincipBuyersNotifsNumber: getPrincipBuyersNotifsNumber,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'buyersList',
                    },
                },
            })
            .state('app.principal.consult.containers', {
                url: '/list-containers',
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'containersList',
                    },
                },
            })
            .state('app.principal.consult.group', {
                url: '/group',
                resolve: {
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                },
                views: {
                    content: {
                        component: 'principalGroup',
                    },
                },
            })
            .state('app.principal.consult.group-creation', {
                url: '/group/create',
                resolve: {
                    creation: function () {
                        return true;
                    },
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    companies: getPrincipalCompanies,
                },
                views: {
                    content: {
                        component: 'principalGroupDetail',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
            })
            .state('app.principal.consult.group-sub-entity-creation', {
                url: '/group/sub-entity/create',
                resolve: {
                    creation: function () {
                        return true;
                    },
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                },
                views: {
                    content: {
                        component: 'principalGroupSubEntity',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
            })
            .state('app.principal.consult.group-sub-entity-edit', {
                url: '/group/sub-entity/edit/{groupId}',
                resolve: {
                    creation: function () {
                        return false;
                    },
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    group: getLegalEntityAndSubEntityForGroup,
                },
                views: {
                    content: {
                        component: 'principalGroupSubEntity',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
            })
            .state('app.principal.consult.group-edit', {
                url: '/group/edit/{groupId}',
                resolve: {
                    creation: function () {
                        return false;
                    },
                    countries: getCountries,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    companies: getPrincipalCompanies,
                    group: getGroup,
                },
                views: {
                    content: {
                        component: 'principalGroupDetail',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
            })
            .state('app.principal.consult.invoiceparam', {
                url: '/invoice-param',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    invoiceTemplateInfo: getInvoiceTemplate,
                    attributes: getFullTemplate,
                    principal: getPrincipal,
                    controlSets: getControlSets,
                    legibleFileId: getLegibleFileId,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'invoiceParam',
                    },
                },
            })
            .state('app.principal.consult.invoicestatements', {
                url: '/invoice-statements',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    principal: getPrincipal,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'invoiceStatements',
                    },
                },
            })
            .state('app.principal.consult.orderparam', {
                url: '/order-param',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    functionalType: () => 'ORDER',
                    documentModel: getDocumentModel,
                    attributes: getDictionary,
                    modelContext: getModelContext,
                    controlSets: getControlSetsDocument,
                    controlSetsCancellation: getControlSetsCancellation,
                    sections: getSectionForOrderParam,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'orderParam',
                    },
                },
            })
            .state('app.principal.consult.responseparam', {
                url: '/response-param',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    functionalType: () => 'RESPONSE',
                    documentModel: getDocumentModel,
                    attributes: getDictionary,
                    modelContext: getModelContext,
                    controlSets: getControlSetsDocument,
                    sections: getSectionForResponseParam,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'responseParam',
                    },
                },
            })
            .state('app.principal.consult.desadvparam', {
                url: '/desadv-param',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    functionalType: () => 'DESADV',
                    documentModel: getDocumentModel,
                    principal:getPrincipal,
                    attributes: getDictionary,
                    modelContext: getModelContext,
                    controlSets: getControlSetsDocument,
                    sections: getSectionForDesadvParam,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'desadvParam',
                    },
                },
            })
            .state('app.principal.consult.recadvparam', {
                url: '/recadv-param',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    functionalType: () => 'RECADV',
                    documentModel: getDocumentModel,
                    attributes: getDictionary,
                    modelContext: getModelContext,
                    controlSets: getControlSetsDocument,
                    sections: getSectionForRecadvParam,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'recadvParam',
                    },
                },
            })
            .state('app.principal.consult.detailsinvitation', {
                url: '/invitation/{invitationId}',
                params: { entity: null },
                resolve: {
                    entity: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().entity;
                        },
                    ],
                    type: function () {
                        return 'seller';
                    },
                    invitation: getInvitation,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'invitationDetails',
                    },
                },
            })
            .state('app.principal.consult.detailsbuyerinvitation', {
                url: '/invitation-buyer/{invitationId}',
                params: { entity: null },
                resolve: {
                    entity: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().entity;
                        },
                    ],
                    type: function () {
                        return 'buyer';
                    },
                    invitation: getBuyerInvitation,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'invitationDetails',
                    },
                },
            })
            .state('app.principal.consult.users', {
                url: '/users',
                resolve: {
                    keepSearchData: keepSearchData,
                    ladProviders: () => null,
                    countries: () => null,
                    principal: getPrincipal,
                    groups: getPrincipalGroups,
                },
                views: {
                    content: {
                        component: 'principalUser',
                    },
                },
            })
            .state('app.principal.consult.create-user', {
                url: '/users/create',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    groups: getPrincipalGroups,
                    userBoData: getUserCreationData,
                    mustBeAdminFo: getMustBeAdminFo,
                    canHaveSalesAdmin: canHaveSalesAdmin,
                },
                views: {
                    content: {
                        component: 'principalUserDetail',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
                params: { mustBeAdminFo: null, principalId: null },
            })
            .state('app.principal.consult.edit-user', {
                url: '/users/edit/{userId}',
                resolve: {
                    userBoData: getUser,
                    groups: getPrincipalGroups,
                    principal: getPrincipal,
                    countries: () => null,
                    ladProviders: () => null,
                    isSingleAdminFo: isUserSingleAdminFo,
                    canHaveSalesAdmin: canHaveSalesAdmin,
                },
                views: {
                    content: {
                        component: 'principalUserDetail',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
            })
            .state('app.principal.sellerrelations', {
                url: '/seller/relations/:id',
                params: { principalInfo: null },
                resolve: {
                    sellerBo: getSeller,
                    relations: getSellerRelations,
                    countries: getCountries,
                    principalInfo: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().principalInfo;
                        },
                    ],
                },

                component: 'sellerRelations',
            })
            .state('app.principal.companyrelations', {
                url: '/company/relations/:id',
                params: { principalInfo: null, companyInfo: null },
                resolve: {
                    pageRelations: getCompanyRelations,
                    countries: getCountries,
                    principalInfo: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().principalInfo;
                        },
                    ],
                    companyInfo: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().companyInfo;
                        },
                    ],
                },
                component: 'companyRelations',
            })
            .state('app.principal.invbuyerrelations', {
                url: '/buyer/relations/:id',
                params: { principalInfo: null },
                resolve: {
                    invBuyerBo: getInvitedBuyer,
                    relations: getInvBuyerRelations,
                    countries: getCountries,
                    principalInfo: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().principalInfo;
                        },
                    ],
                },
                component: 'invBuyerRelations',
            })
            .state('app.principal.invbuy-subentity-relations', {
                url: '/inv_buyer/sub_entity/relations/:subEntityId',
                resolve: {
                    subEntity: getSubEntity,
                    relations: getInvBuyerSubEntityRelations,
                    countries: getCountries,
                },
                component: 'invBuyerSubEntityRelations',
            })
            .state('app.principal.consult.reports', {
                url: '/reports',
                resolve: {
                    ladProviders: () => null,
                    countries: () => null,
                    principal: getPrincipal,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'reports',
                    },
                },
            })
            .state('app.principal.consult.check_config', {
                url: '/checkConfig',
                resolve: {
                    ladProviders: listLadProviders,
                    countries: () => null,
                    principal: getPrincipal,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-check-config-all-head.html'),
                    },
                    content: {
                        component: 'principalCheckConfigAll',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
            })
            .state('app.principal.consult.export_config', {
                url: '/exportConfig',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    principal: getPrincipal,
                    type: function () {
                        return 'export_configuration';
                    },
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalExportConfig',
                    },
                },
                data: {
                    authorizedRole: 'CONFIGURATOR',
                },
            })
            .state('app.principal.consult.buyer', {
                url: '/buyer',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    principal: getPrincipal,
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'principalBuyer',
                    },
                },
            })
            .state('app.principal.consult.billing_address', {
                url: '/:legalEntityId/billing-address-create',
                resolve: {
                    ladProviders: () => null,
                    principal: getPrincipal,
                    legalEntity: getLegalEntity,
                    countries: getCountries,
                    previousState: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().previousState;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'billingAddressDetails',
                    },
                },
                params: {
                    previousState: null,
                    forEdit: false,
                },
                data: {
                    authorizedRole: 'CONFIGURATOR',
                },
            })
            .state('app.principal.consult.edit-billing_address', {
                url: '/:legalEntityId/billing-address-edit/:billingAddressId',
                resolve: {
                    ladProviders: () => null,
                    principal: getPrincipal,
                    legalEntity: getLegalEntity,
                    countries: getCountries,
                    billingAddress: getBillingAddress,
                    previousState: [
                        '$transition$',
                        function ($transition$) {
                            return $transition$.params().previousState;
                        },
                    ],
                },
                views: {
                    principalInfo: {
                        templateUrl: require('./principal-info.html'),
                    },
                    content: {
                        component: 'billingAddressDetails',
                    },
                },
                params: {
                    previousState: null,
                    forEdit: true,
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
            })

             ;

        getCreatePrincipal.$inject = ['PrincipalSvc'];
        function getCreatePrincipal(PrincipalSvc) {
            return PrincipalSvc.getCreatePrincipal();
        }

        getNewLegalEntity.$inject = ['PrincipalSvc'];
        function getNewLegalEntity(PrincipalSvc) {
            return PrincipalSvc.getNewLegalEntity();
        }

        getCountries.$inject = ['CountrySvc'];
        function getCountries(CountrySvc) {
            return CountrySvc.getAll();
        }

        listLadProviders.$inject = ['LadProvidersDA'];
        function listLadProviders(LadProvidersDA) {
            return LadProvidersDA.getAll();
        }

        documentarySpace.$inject = ['PrincipalSvc'];
        function documentarySpace(PrincipalSvc) {
            return PrincipalSvc.getDocumentarySpace(PrincipalSvc.getPrincipalId());
        }

        setPrincipalId.$inject = ['$transition$', 'PrincipalSvc'];
        function setPrincipalId($transition$, PrincipalSvc) {
            return PrincipalSvc.setPrincipalId($transition$.params().id);
        }

        initMenuConsult.$inject = ['setPrincipalId', 'PrincipalSvc'];
        function initMenuConsult(setPrincipalId, PrincipalSvc) {
            return PrincipalSvc.initMenuConsult(PrincipalSvc.getPrincipalId());
        }

        getPrincipalStatus.$inject = ['setPrincipalId', 'initMenuConsult', 'PrincipalSvc'];
        function getPrincipalStatus(setPrincipalId, initMenuConsult, PrincipalSvc) {
            return PrincipalSvc.refreshPrincStatus(PrincipalSvc.getPrincipalId());
        }

        getPrincipBuyersNotifsNumber.$inject = ['setPrincipalId', 'initMenuConsult', 'PrincipalSvc'];
        function getPrincipBuyersNotifsNumber(setPrincipalId, initMenuConsult, PrincipalSvc) {
            return PrincipalSvc.refreshPrincipalBuyersNotifsUnsent(PrincipalSvc.getPrincipalId());
        }

        getPrincipal.$inject = ['countries', 'ladProviders', 'setPrincipalId', 'PrincipalSvc'];
        function getPrincipal(countries, ladProviders, setPrincipalId, PrincipalSvc) {
            return PrincipalSvc.refreshPrincipal(PrincipalSvc.getPrincipalId(), countries, ladProviders);
        }

        getBrand.$inject = ['BrandSvc', 'PrincipalSvc'];
        function getBrand(BrandSvc, PrincipalSvc) {
            return PrincipalSvc.getBrand(PrincipalSvc.getPrincipalId());
        }

        getInvoiceTemplate.$inject = ['PrincipalSvc', 'InvoiceTemplateDA'];
        function getInvoiceTemplate(PrincipalSvc, InvoiceTemplateDA) {
            return InvoiceTemplateDA.getInvoiceTemplate(PrincipalSvc.getPrincipalEid());
        }

        getDocumentModel.$inject = ['PrincipalSvc', 'DocumentModelDA', 'functionalType'];
        function getDocumentModel(PrincipalSvc, DocumentModelDA, functionalType) {
            return DocumentModelDA.getDocumentModel(PrincipalSvc.getPrincipalEid(), functionalType);
        }

        getControlSetsDocument.$inject = ['PrincipalSvc', 'DocumentModelDA', 'functionalType'];
        function getControlSetsDocument(PrincipalSvc, DocumentModelDA, functionalType) {
            return DocumentModelDA.getControlSets(PrincipalSvc.getPrincipalEid(), functionalType);
        }

        getControlSetsCancellation.$inject = ['PrincipalSvc', 'DocumentModelDA'];
        function getControlSetsCancellation(PrincipalSvc, DocumentModelDA) {
            return DocumentModelDA.getControlSets(PrincipalSvc.getPrincipalEid(), 'CANCELLATION');
        }

        getSectionForOrderParam.$inject = ['ORDER_PARAM'];
        function getSectionForOrderParam(ORDER_PARAM) {
            return ORDER_PARAM.sectionsOrder;
        }

        getSectionForResponseParam.$inject = ['ORDER_PARAM'];
        function getSectionForResponseParam(ORDER_PARAM) {
            return ORDER_PARAM.sectionsResponse;
        }

        getSectionForDesadvParam.$inject = ['ORDER_PARAM'];
        function getSectionForDesadvParam(ORDER_PARAM) {
            return ORDER_PARAM.sectionsDesadv;
        }

        getSectionForRecadvParam.$inject = ['ORDER_PARAM'];
        function getSectionForRecadvParam(ORDER_PARAM) {
            return ORDER_PARAM.sectionsRecadv;
        }

        getControlSets.$inject = ['PrincipalSvc', 'InvoiceTemplateDA'];
        function getControlSets(PrincipalSvc, InvoiceTemplateDA) {
            return InvoiceTemplateDA.getControlSets(PrincipalSvc.getPrincipalEid());
        }

        getLegibleFileId.$inject = ['PrincipalSvc', 'InvoiceTemplateDA'];
        function getLegibleFileId(PrincipalSvc, InvoiceTemplateDA) {
            return InvoiceTemplateDA.getLegibleFileId(PrincipalSvc.getPrincipalEid());
        }

        getFullTemplate.$inject = ['PrincipalSvc', 'InvoiceTemplateDA'];
        function getFullTemplate(PrincipalSvc, InvoiceTemplateDA) {
            return InvoiceTemplateDA.getFullTemplate(PrincipalSvc.getPrincipalEid());
        }

        getDictionary.$inject = ['PrincipalSvc', 'DocumentModelDA', 'functionalType'];
        function getDictionary(PrincipalSvc, DocumentModelDA, functionalType) {
            return DocumentModelDA.getDictionary(PrincipalSvc.getPrincipalEid(), functionalType);
        }

        getDictionaryAttributs.$inject = ['PrincipalSvc', 'DocumentModelDA', 'functionalType'];
        function getDictionaryAttributs(PrincipalSvc, DocumentModelDA, functionalType) {
            return DocumentModelDA.getDictionaryAttributs(PrincipalSvc.getPrincipalId(), functionalType);
        }
        getOffresApi.$inject = ['PrincipalSvc'];
        function getOffresApi(PrincipalSvc) {
            return PrincipalSvc.getOffresApi(PrincipalSvc.getPrincipalId());
        }

        getOffresApiForLegalEntity.$inject = ['PrincipalSvc'];
        function getOffresApiForLegalEntity(PrincipalSvc) {
            return PrincipalSvc.getOffresApiForLegalEntity(PrincipalSvc.getPrincipalId());
        }

        getLegalEntity.$inject = ['PrincipalSvc', '$transition$'];
        function getLegalEntity(PrincipalSvc, $transition$) {
            return PrincipalSvc.getLegalEntity(PrincipalSvc.getPrincipalId(), $transition$.params().legalEntityId);
        }

        getBillingAddress.$inject = ['BillingAddressSvc', '$transition$'];
        function getBillingAddress(BillingAddressSvc, $transition$) {
            return BillingAddressSvc.getBillingAddress($transition$.params().billingAddressId);
        }

        getRegScheme.$inject = ['legalEntity', 'RegistrationSchemesDA'];
        function getRegScheme(legalEntity, RegistrationSchemesDA) {
            return RegistrationSchemesDA.getByCountry(legalEntity.countryCode);
        }

        getInvitation.$inject = ['$transition$', 'PrincipalSvc'];
        function getInvitation($transition$, PrincipalSvc) {
            return PrincipalSvc.getInvitation($transition$.params().invitationId);
        }

        getBuyerInvitation.$inject = ['$transition$', 'PrincipalSvc'];
        function getBuyerInvitation($transition$, PrincipalSvc) {
            return PrincipalSvc.getBuyerInvitation($transition$.params().invitationId);
        }

        getSeller.$inject = ['$transition$', 'KissSellerSvc'];
        function getSeller($transition$, KissSellerSvc) {
            return KissSellerSvc.getSeller($transition$.params().id);
        }

        getSellerRelations.$inject = ['PrincipalSvc', 'sellerBo', 'SellerRelationFilter', 'KissSellerSvc'];
        function getSellerRelations(PrincipalSvc, sellerBo, SellerRelationFilter, KissSellerSvc) {
            var sellerFilter = new SellerRelationFilter();
            sellerFilter.principal = PrincipalSvc.getPrincipal() ? PrincipalSvc.getPrincipal().detail : null;
            return KissSellerSvc.searchRelations(sellerBo.seller.legalEntity.id, sellerFilter);
        }

        getCompanyRelations.$inject = ['$transition$', 'PrincipalSvc', 'CompanyService', 'CompanyRelationFilter'];
        function getCompanyRelations($transition$, PrincipalSvc, CompanyService, CompanyRelationFilter) {
            var companyFilter = new CompanyRelationFilter();
            companyFilter.principal = PrincipalSvc.getPrincipal() ? PrincipalSvc.getPrincipal().detail : null;
            var filter = companyFilter.preparBeforeSearch();
            return CompanyService.searchRelations({ companyId: $transition$.params().id }, filter).$promise;
        }

        getPrincipalCompanies.$inject = ['PrincipalSvc', 'PrincipalsDA'];
        function getPrincipalCompanies(PrincipalSvc, PrincipalsDA) {
            return PrincipalsDA.listCompanies(PrincipalSvc.getPrincipalId());
        }

        getLegalEntityAndSubEntityForGroup.$inject = ['PrincipalsDA', '$transition$'];
        function getLegalEntityAndSubEntityForGroup(PrincipalsDA, $transition$) {
            return PrincipalsDA.getLegalEntityAndSubEntityForGroup($transition$.params().groupId);
        }

        /**
         * Recherche un groupe par son identifiant.
         */
        getGroup.$inject = ['PrincipalSvc', 'PrincipalsDA', '$transition$'];
        function getGroup(PrincipalSvc, PrincipalsDA, $transition$) {
            return PrincipalsDA.getGroup(PrincipalSvc.getPrincipalId(), $transition$.params().groupId);
        }

        keepSellerSearchData.$inject = ['$transition$'];
        function keepSellerSearchData($transition$) {
            var referer = $transition$.from().name;
            return (
                referer === 'app.kissseller.edit' ||
                referer === 'app.principal.sellerrelations' ||
                referer === 'app.principal.consult.detailsinvitation'
            );
        }

        keepCompanySearchData.$inject = ['$transition$'];
        function keepCompanySearchData($transition$) {
            return $transition$.from().name === 'app.principal.consult.detailscompanies';
        }

        keepSearchData.$inject = ['$transition$'];
        function keepSearchData($transition$) {
            return $transition$.from().name === 'app.principal.consult.edit-user';
        }

        getUserCreationData.$inject = ['KissUserSvc'];
        function getUserCreationData(KissUserSvc) {
            return KissUserSvc.getUserCreationData();
        }

        getMustBeAdminFo.$inject = ['$transition$', 'KissUserSvc', 'UsersFilter'];
        function getMustBeAdminFo($transition$, KissUserSvc, UsersFilter) {
            return $transition$.params().mustBeAdminFo
                ? true
                : KissUserSvc.searchUsers(
                      new UsersFilter({ principalId: $transition$.params().principalId, role: 'ADMIN_FO' })
                  ).then(
                      function (pageUsers) {
                          // on verifie s'il y a deja un ADMIN_FO si existe alors on ne force pas le choix d'ADMIN_FO
                          return !(pageUsers.totalItems > 0);
                      },
                      () => {
                          this.logger.error('error.search');
                      }
                  );
        }

        canHaveSalesAdmin.$inject = ['PrincipalSvc'];
        function canHaveSalesAdmin(PrincipalSvc) {
            return PrincipalSvc.canHaveSalesAdmin(PrincipalSvc.getPrincipalId());
        }

        getUser.$inject = ['$transition$', 'KissUserSvc'];
        function getUser($transition$, KissUserSvc) {
            return KissUserSvc.getUser($transition$.params().userId);
        }

        getPrincipalGroups.$inject = ['PrincipalSvc', 'TYPEGROUPE'];
        function getPrincipalGroups(PrincipalSvc, TYPEGROUPE) {
            /** Type du groupe : (ALL, STANDARD,INVITED_SELLER). */
            let criteria = {};
            criteria.types = [TYPEGROUPE.all, TYPEGROUPE.standard];
            return PrincipalSvc.searchGroups(PrincipalSvc.getPrincipalId(), criteria);
        }

        isUserSingleAdminFo.$inject = ['$transition$', 'PrincipalSvc'];
        function isUserSingleAdminFo($transition$, PrincipalSvc) {
            return PrincipalSvc.isUserSingleAdminFo(PrincipalSvc.getPrincipalId(), $transition$.params().userId);
        }

        getInvBuyerRelations.$inject = ['PrincipalSvc', 'invBuyerBo', 'InvBuyerRelationFilter', 'invitedEntitySvc'];
        function getInvBuyerRelations(PrincipalSvc, invBuyerBo, InvBuyerRelationFilter, invitedEntitySvc) {
            var filter = new InvBuyerRelationFilter();
            filter.principal = PrincipalSvc.getPrincipal() ? PrincipalSvc.getPrincipal().detail : null;
            return invitedEntitySvc.searchInvBuyerRelations(invBuyerBo.invitedEntity.legalEntity.id, filter);
        }

        getInvitedBuyer.$inject = ['$transition$', 'invitedEntitySvc'];
        function getInvitedBuyer($transition$, invitedEntitySvc) {
            return invitedEntitySvc.getInvitedEntityBuyer($transition$.params().id);
        }

        getSubEntity.$inject = ['$transition$', 'PrincipalSvc'];
        function getSubEntity($transition$, PrincipalSvc) {
            return PrincipalSvc.getSubEntity($transition$.params().subEntityId);
        }

        getCgvOfSubEntity.$inject = ['$transition$', 'PrincipalSvc'];
        function getCgvOfSubEntity($transition$, PrincipalSvc) {
            return PrincipalSvc.getCgvOfSubEntity($transition$.params().subEntityId);
        }

        getInvBuyerSubEntityRelations.$inject = ['$transition$', 'KissSellerSvc', 'InvBuyerSubEntityRelationFilter'];
        function getInvBuyerSubEntityRelations($transition$, KissSellerSvc, InvBuyerSubEntityRelationFilter) {
            var filter = new InvBuyerSubEntityRelationFilter();
            return KissSellerSvc.getSubEntityRelations($transition$.params().subEntityId, filter);
        }

        getModelContext.$inject = ['countries', 'ladProviders', 'PrincipalSvc', 'ModelContext'];
        function getModelContext(countries, ladProviders, PrincipalSvc, ModelContext) {
            return PrincipalSvc.refreshPrincipal(PrincipalSvc.getPrincipalId(), countries, ladProviders).then(
                principal => new ModelContext(principal.detail, 'principal', true, principal.kiss.paramKiss),
                () => this.logger.error('error.search')
            );
        }

        getAllDematPlatforms.$inject = ['PrincipalSvc'];
        function getAllDematPlatforms(PrincipalSvc) {
            return PrincipalSvc.getAllDematPlatforms();
        }
    }
})();
